import React from 'react';

const InternToggleSwitch = (props) => {

    return (
        <>
            <label className="switch">
                <input type="checkbox"
                       checked={props.isChecked? 'checked': ''}
                       onChange={props.handleToggle}
                />
                <span className="slider round"></span>
            </label>
        </>
    );
}

export default InternToggleSwitch